// All work: every graded deliverable for the semester, filterable, editable inline.

import { CLASSES } from "../data/classes.js";
import { d, MON } from "../lib/dates.js";
import { byId, el, truthyKeys } from "../lib/dom.js";
import { itemRow, ownersOf } from "../lib/items.js";
import { S } from "../lib/state.js";
import { editorForm } from "./editor.js";

function renderFilters(onChange) {
  const host = byId("allFilters");
  host.innerHTML = "";

  const toggle = (map, key, label) => {
    const b = el("button", "chip", label);
    b.setAttribute("aria-pressed", map[key] ? "true" : "false");
    b.onclick = () => {
      map[key] ? delete map[key] : (map[key] = true);
      onChange();
    };
    return b;
  };

  CLASSES.forEach((c) => host.appendChild(toggle(S.filt.cls, c.id, c.id)));
  host.appendChild(el("div", "div"));
  [["group", "Team"], ["individual", "Individual"], ["exam", "Exams"]].forEach(([k, label]) =>
    host.appendChild(toggle(S.filt.kind, k, label))
  );
  host.appendChild(el("div", "div"));

  const mine = el("button", "chip", "Mine only");
  mine.setAttribute("aria-pressed", S.filt.mine ? "true" : "false");
  mine.onclick = () => {
    S.filt.mine = !S.filt.mine;
    onChange();
  };
  host.appendChild(mine);

  const hideDone = el("button", "chip", "Hide done");
  hideDone.setAttribute("aria-pressed", S.filt.hideDone ? "true" : "false");
  hideDone.onclick = () => {
    S.filt.hideDone = !S.filt.hideDone;
    onChange();
  };
  host.appendChild(hideDone);
}

function passes(it) {
  const classes = truthyKeys(S.filt.cls);
  const kinds = truthyKeys(S.filt.kind);
  if (classes.length && !classes.includes(it.cls)) return false;
  if (kinds.length && !kinds.includes(it.kind)) return false;
  if (S.filt.hideDone && it.status === "done") return false;
  if (S.filt.mine && !ownersOf(it).includes(S.me)) return false;
  return true;
}

/**
 * @param {object} items          store snapshot
 * @param {object} handlers       { onSave, onDelete, rerender }
 */
export function render(items, handlers) {
  renderFilters(handlers.rerender);

  const addHost = byId("addFormHost");
  addHost.innerHTML = "";
  if (S.adding) {
    editorForm(null, addHost, (result) => {
      S.adding = false;
      if (result) handlers.onSave(result);
      handlers.rerender();
    });
  }

  const list = Object.values(items)
    .filter(passes)
    .sort((a, b) => (a.due < b.due ? -1 : a.due > b.due ? 1 : a.cls < b.cls ? -1 : 1));

  const body = byId("allBody");
  body.innerHTML = "";
  if (!list.length) {
    body.appendChild(el("div", "empty", "No deliverables match those filters."));
    return;
  }

  let currentMonth = null;
  list.forEach((it) => {
    const month = d(it.due).getMonth();
    if (month !== currentMonth) {
      currentMonth = month;
      const h = el("div", "week-head", `<h3>${MON[month]} 2026</h3>`);
      h.style.marginTop = "22px";
      body.appendChild(h);
    }
    body.appendChild(itemRow(it));

    if (S.editing === it.id) {
      const host = el("div");
      body.appendChild(host);
      editorForm(it, host, (result) => {
        S.editing = null;
        if (result) result.__delete ? handlers.onDelete(result.id) : handlers.onSave(result);
        handlers.rerender();
      });
    }
  });
}
